import cn from 'classnames';
import Button from 'components/Button';
import Columns from 'components/Columns';
import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { imageBlock, isLeft, isSmallIcon, root, textBlock } from './IconContent.module.scss';

const IconContent = ({ data, theme, padding, cta, wrapper, smallIcon, columnCount, alignLeft }) => {
  const Item = ({ heading, content, img }) => {
    const createMarkup = item => ({ __html: item });
    return (
      <div className={cn(root, { [isLeft]: alignLeft, [isSmallIcon]: smallIcon })}>
        <div className={imageBlock}>
          <img src={img.publicURL} alt={heading} />
        </div>
        <div className={textBlock}>
          {heading && (
            <Heading Tag="h3" bold center={alignLeft ? false : true} size="SM" marginBottom="Xxs">
              {heading}
            </Heading>
          )}
          <P><span dangerouslySetInnerHTML={createMarkup(content)}></span></P>
        </div>
      </div>
    );
  };
  Item.propTypes = {
    heading: PropTypes.string,
    content: PropTypes.string,
    img: PropTypes.object.isRequired,
  };

  return (
    <Section padding={padding} theme={theme}>
      <Wrapper size={wrapper}>
        <Columns Item={Item} items={data} columnCount={columnCount} columnGap="L" />
        {cta && (
          <div className="align-item-center mt-l">
            <Button
              href={cta.btnLink}
              text={cta.btnText}
              type="secondary"
              size="L"
              openNew={cta.openNew}
            />
          </div>
        )}
      </Wrapper>
    </Section>
  );
};

IconContent.propTypes = {
  data: PropTypes.array.isRequired,
  theme: PropTypes.string,
  wrapper: PropTypes.string,
  padding: PropTypes.string,
  cta: PropTypes.shape({
    btnLink: PropTypes.string,
    btnText: PropTypes.string,
    openNew: PropTypes.bool,
  }),
  smallIcon: PropTypes.bool,
  columnCount: PropTypes.number,
  alignLeft: PropTypes.bool,
};

IconContent.defaultProps = {
  padding: 'BottomL',
  theme: null,
  wrapper: 'ML',
  smallIcon: false,
  columnCount: 3,
  alignLeft: false,
};

export default IconContent;
